import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import Select from '@mui/material/Select';
import UserTable from './UserTable';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

const AdminUsers = () => {
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState('');

  const handleQuery = (e) => {
    getFilteredUsers();
  };

  const getFilteredUsers = async (options = {}) => {
    setLoading(true);
    setInfo('');
    if (!options.preserve) {
      setAllUsers([]);
    }
    try {
      const response = await axios({
        method: 'POST',
        url: '/api/v1/admin/getFilteredUsers',
        data: { roles, statuses, emailVerifieds, giveAways, dates },
      });

      setAllUsers(response.data.data.users);
    } catch (err) {
      setInfo(err.response.data.message);
      console.log('Error->', err.response.data.message);
    }
    setLoading(false);
  };
  const refreshFilteredUsers = async () => {
    await getFilteredUsers({ preserve: true });
  };

  const [roles, setRoles] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [emailVerifieds, setEmailVerifieds] = useState([]);
  const [giveAways, setGiveAways] = useState([]);
  const [dates, setDates] = useState('');

  const handleChangeRoles = (event) => {
    setRoles(event.target.value);
  };
  const handleChangeStatuses = (event) => {
    setStatuses(event.target.value);
  };
  const handleChangeEmailVerifieds = (event) => {
    setEmailVerifieds(event.target.value);
  };
  const handleChangeGiveAways = (event) => {
    setGiveAways(event.target.value);
  };
  const handleChangeDate = (event) => {
    setDates(event.target.value);
  };
  const handleClearFilters = () => {
    setRoles([]);
    setStatuses([]);
    setEmailVerifieds([]);
    setGiveAways([]);
    setDates('');
  };
  const roleValues = ['basic', 'standard', 'premium', 'professional', 'support', 'admin'];
  const statusValues = ['active', 'passive'];
  const emailVerifiedValues = ['yes', 'no'];
  const giveAwayValues = ['yes', 'no'];
  const dateValues = [
    'Last 3 days',
    'Last 7 days',
    'Last 30 days',
    'Last 90 days',
    'Last 180 days',
    'Last 365 days',
    'Last 2 years',
    'From the beginning',
  ];

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 5;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };

  return (
    <div className="adminUsers">
      <h1>Filter Users</h1>
      <div className="adminUsersSearch">
        <FormControl sx={{ m: 1, width: 250 }}>
          <InputLabel id="demo-multiple-checkbox-label">Date</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            value={dates}
            onChange={handleChangeDate}
            input={<OutlinedInput label="Date" />}
            renderValue={(selected) => selected}
            MenuProps={MenuProps}
          >
            {dateValues.map((date) => (
              <MenuItem key={date} value={date}>
                <Checkbox checked={dates === date} />
                <ListItemText primary={date} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, width: 120 }}>
          <InputLabel id="demo-multiple-checkbox-label">Role</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={roles}
            onChange={handleChangeRoles}
            input={<OutlinedInput label="Roles" />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={MenuProps}
          >
            {roleValues.map((role) => (
              <MenuItem key={role} value={role}>
                <Checkbox checked={roles.includes(role)} />
                <ListItemText primary={role} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, width: 120 }}>
          <InputLabel id="demo-multiple-checkbox-label">Status</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={statuses}
            onChange={handleChangeStatuses}
            input={<OutlinedInput label="Status" />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={MenuProps}
          >
            {statusValues.map((status) => (
              <MenuItem key={status} value={status}>
                <Checkbox checked={statuses.includes(status)} />
                <ListItemText primary={status} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, width: 150 }}>
          <InputLabel id="demo-multiple-checkbox-label">Email Verified</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={emailVerifieds}
            onChange={handleChangeEmailVerifieds}
            input={<OutlinedInput label="Email Verified" />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={MenuProps}
          >
            {emailVerifiedValues.map((emailVerified) => (
              <MenuItem key={emailVerified} value={emailVerified}>
                <Checkbox checked={emailVerifieds.includes(emailVerified)} />
                <ListItemText primary={emailVerified} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, width: 150 }}>
          <InputLabel id="demo-multiple-checkbox-label">Give Away</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={giveAways}
            onChange={handleChangeGiveAways}
            input={<OutlinedInput label="Give Away" />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={MenuProps}
          >
            {giveAwayValues.map((giveAway) => (
              <MenuItem key={giveAway} value={giveAway}>
                <Checkbox checked={giveAways.includes(giveAway)} />
                <ListItemText primary={giveAway} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, width: 150 }}>
          <Button sx={{ m: 1, width: 150 }} variant="outlined" onClick={handleClearFilters}>
            Clear Filters
          </Button>
        </FormControl>
      </div>
      <div className="adminUsersSearchButton">
        <Button variant="contained" onClick={handleQuery}>
          Search users
        </Button>
      </div>
      {loading && allUsers.length === 0 ? (
        <CircularProgress sx={{ m: 3 }} />
      ) : (
        allUsers.length > 0 && <UserTable allUsers={allUsers} onRefresh={refreshFilteredUsers} />
      )}
      {loading && allUsers.length > 0 && <CircularProgress sx={{ m: 2 }} />}
      {info && <div className="AdminUserInfo">{info}</div>}
    </div>
  );
};

export default AdminUsers;
